import { render, staticRenderFns } from "./3BReport.vue?vue&type=template&id=f28feb3a&"
import script from "./3BReport.vue?vue&type=script&lang=js&"
export * from "./3BReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports